<template>
    <!-- Page Content Wrapper -->
    <div v-if="permissionsArray.includes('manage_email_notification')" id="page-content-wrapper" class="admin-content-area dashboard">
        <div class="container-fluid xyz location-listing">
            <div class="page-header-top-container" style="position: fixed;">
                <div class="page-name" style="width:40%">Form Email Manager List</div>
                <button type="submit" v-on:click.prevent="addFormEmailManager()" class="btn btn-primary waves-effect pull-right">Add</button>
                <button type="submit" v-on:click.prevent="loadCustNotificationModel()" class="btn btn-primary waves-effect pull-right">Add Customer Notification</button>
                <button v-show="selectedRows > 1 && selectedRows <= 75" type="button" v-on:click.prevent="editSelected()" class="btn btn-primary waves-effect pull-right"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Multi-Edit ({{selectedRows}})<!-- Record(s)--></button>
                <button type="submit" id='refreshList' title='Refresh' class="extraFeature btn btn-primary waves-effect pull-right ml-2" v-on:click.prevent="loadFormEmailManager()">
                    <i class="fa fa-rotate-right" aria-hidden="true"></i>
                </button>
            </div>
            <!--page content-->
            <div class="admin-page-content" style="padding-top: 100px;">
                <div class="app-filter-good-table-container">
                    <vue-good-table
                        ref="listFormEmailManager"
                        mode="remote"
                        title="Form Email Manager"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        @on-selected-rows-change="selectionChanged"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :selectOptions="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'both',
                            perPage: serverParams.perPage,
                            setCurrentPage: serverParams.setCurrentPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                        }"
                        :search-options="{
                            enabled: false,
                        }">

                        <!-- Custome Pagination -->
                        <template slot="pagination-top" slot-scope="props">
                            <div class="vgt-wrap__footer top-pagination crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->

                        <!-- Custome Pagination -->
                        <template slot="pagination-bottom" slot-scope="props">
                            <div class="vgt-wrap__footer crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                                  v-model="serverParams.perPage"
                                                  @change="changedValueTask"
                                                  @input="changedValueTaskCustomPerPageTask()"
                                                  name="customPerPage"
                                                  id="customPerPage"
                                                  label="text"
                                                  :clearable="false"
                                                  :searchable="false"
                                                  :filterable="false"
                                                  :options="serverParams.perPageDropdown"
                                                  placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action'">
                                    <router-link class="btn edit-btn-vvg waves-effect" title="Edit" v-bind:to="{name: 'UpdateFormEmailManager', params:{id:props.row.id}}">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                    </router-link>
                                    <a href="javascript:void(0)" @click="deleteFormEmailManager(props.row.id)" title='Delete' class="btn edit-btn-vvg waves-effect">
                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <div v-else-if="props.column.field == 'to_email'">
                                    <p v-html="addNewLineInInovoiceColumn(props.formattedRow['to_email'])"></p>
                                </div>
                                <div v-else-if="props.column.field == 'cc_email'">
                                    <p v-html="addNewLineInInovoiceColumn(props.formattedRow['cc_email'])"></p>
                                </div>
                                <div v-else>{{props.formattedRow[props.column.field]}}</div>
                            </div>
                        </template>
                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button v-on:click="deleteFormEmailManager()" class="btn btn-success" title="Delete">Delete</button>
                        </div>
                    </vue-good-table>

                    <!-- Import Modal -->
                    <div class="modal fade" id="addCustNotificationModal" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg cutomerNotification" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="defaultModalLabel">Add Customer Notification</h4>
                                </div>
                                <form id="importCallform" enctype="multipart/form-data">
                                    <div class="modal-body">
                                        <div class="container">
                                            <!-- Notification Type -->
                                            <div class="row form-group">
                                                <div class="col-3">
                                                    <div class="form-label">Notification Type :</div>
                                                </div>
                                                <div class="col-9 customer-selectbox">
                                                    <v-select class="multi-select-list" 
                                                        multiple
                                                        v-model="notificationType"
                                                        name="notificationType"
                                                        id="notificationType"
                                                        label="text"
                                                        @change="changedValue"
                                                        :options="notificationTypeArr"
                                                        :clearable=false
                                                        :searchable="false"
                                                        @input="notificationTypeError = ''"
                                                        placeholder="Select Notification Type">
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="requiredstar">*</div>
                                                    <span class="help is-danger">{{notificationTypeError}}</span>
                                                </div>
                                            </div>
                                            <!-- Customer -->
                                            <div class="row form-group">
                                                <div class="col-3">
                                                    <div class="form-label">Customer :</div>
                                                </div>
                                                <div class="col-9 customer-selectbox">
                                                    <v-select v-model="customerId"
                                                        name="customerId"
                                                        id="customerId"
                                                        label="text"
                                                        :filterable="true"
                                                        :options="customerArr"
                                                        :clearable=false
                                                        @input="onChnageCustomer()"
                                                        placeholder="Select Customer">
                                                    </v-select>
                                                    <div class="requiredstar">*</div>
                                                    <span class="help is-danger">{{customerError}}</span>
                                                </div>
                                            </div>
                                            <!-- To Email -->
                                            <div class="row form-group">
                                                <div class="col-3">
                                                    <div class="form-label">To Email :</div>
                                                </div>
                                                <div class="col-9 customer-textbox">
                                                    <vue-tags-input
                                                        v-model="toEmail"
                                                        :tags="toEmailTagsArr"
                                                        :validation="validation"
                                                        @tags-changed="newTags => toEmailTagsArr = newTags"
                                                        @before-adding-tag="checkToEmailTag"
                                                        placeholder=""
                                                    />
                                                    <div class="help is-danger">{{toEmailError}}</div>
                                                    <div class="requiredstar">*</div>
                                                </div>
                                            </div>
                                            <!-- CC Email -->
                                            <div class="row form-group">
                                                <div class="col-3">
                                                    <div class="form-label">CC Email :</div>
                                                </div>
                                                <div class="col-9 customer-textbox">
                                                    <vue-tags-input
                                                        v-model="ccEmail"
                                                        :tags="ccEmailTagsArr"
                                                        :validation="validation"
                                                        @tags-changed="newTags => ccEmailTagsArr = newTags"
                                                        @before-adding-tag="checkCCEmailTag"
                                                        placeholder=""
                                                    />
                                                    <div class="help is-danger">{{ccEmailError}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix"></div>
                                    <div class="col-md-12 modal-footer">
                                        <button type="button" v-on:click="saveCutomerNotification();" class="btn general-button btn-success waves-effect" id="saveBtn">{{saveBtnName}}</button>
                                        <button type="button" class="btn general-button btn-danger waves-effect" data-dismiss="modal" id="closeBtn">Close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <div v-else>
        <no-permission></no-permission>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import EventBus from ".././event-bus";
    import { commonMixins } from "../../mixins/commonMixins";
    import { HTTP } from "../../http-common.js";
    import VueGoodTable from "vue-good-table";
    import NoAccessPermission from '../NoAccessPermission';
    import vSelect from 'vue-select';
    import moment from 'moment';
    import VueTagsInput from '@johmun/vue-tags-input';

    Vue.use(VueGoodTable);
    export default {
        name: "ListFormEmailManager",
        components: {
            "app-footer": Footer,
            "no-permission" : NoAccessPermission,
            'v-select': vSelect,
            VueTagsInput,
        },
        mixins: [commonMixins],
        data() {
            return {
                roleId: 0,
                firstLoad: 0,
                columns: [
                    {
                        label: "Customer Name",
                        field: "customer_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Notification Type",
                        field: "notification_type",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Notification Type", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "To Email",
                        field: "to_email",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "To Email", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "CC Email",
                        field: "cc_email",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CC Email", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Actions",
                        field: "action",
                        html: true,
                        sortable: false,
                        thClass: "disable-sorting"
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 'All',
                    sort: {
                        field: "id",
                        type: "asc"
                    },
                    perPageDropdown : [],
                },
                recordsCounts: "",
                selectedRows: 0,
                permissionsArray: ['manage_email_notification'],

                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',

                customerId: "",
                customerArr: [],
                customerError: "",
                notificationType: "",
                notificationTypeArr: [
                    /* {
                        text: 'Audit Close Notification',
                        value: 'Audit Close Notification'
                    },
                    {
                        text: 'Audit not Perform',
                        value: 'Audit not Perform'
                    },
                    {
                        text: 'Backorder Parts Notification',
                        value: 'Backorder Parts Notification'
                    },
                    {
                        text: 'Held-Ticket not available',
                        value: 'Held-Ticket not available'
                    },
                    {
                        text: 'Part Usage Notification',
                        value: 'Part Usage Notification'
                    },
                    {
                        text: 'Pending PO Parts Notification',
                        value: 'Pending PO Parts Notification'
                    }, */
                ],
                notificationTypeError: "",
                validation: [{
                    classes: 'valid-email',
                    rule: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                }],
                toEmail: "",
                toEmailTagsArr: [],
                isValidToEmailTag: true,
                toEmailError: "",
                ccEmail: "",
                ccEmailTagsArr: [],
                isValidCCEmailTag: true,
                ccEmailError: "",
                saveBtnName : 'Save',
                selectedFormEmailManagerDataArr : []
            };
        },
        beforeMount: function() {
            self = this;
            EventBus.$emit("menu-selection-changed", "ListFormEmailManager");
        },
        mounted: function() {
            self.loadFilters('formemailmanagerlist', self.columns, self.serverParams, 'FormEmailManagerList');
            self.getUserPermissions();
            self.windowWidth = $(window).width();
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                /* if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                } */
                // $('.dashboard .admin-page-content.sticky .vgt-responsive').height($(window).height() - 340);
            });
            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });
            this.serverParams.perPageDropdown.push(25);
            this.serverParams.perPageDropdown.push(50);
            this.serverParams.perPageDropdown.push(100);
            this.serverParams.perPageDropdown.push(200);
            this.serverParams.perPageDropdown.push(500);
            this.serverParams.perPageDropdown.push('All');
            self.loadFormEmailManager();
            self.getFormMasterData();

            /* setTimeout(function(){
                var stickyTop12 = 77;
                $(window).scroll(function () {
                    var windowTop = $(window).scrollTop();
                    var el = $('.admin-page-content');
                    if (el.length > 0) {
                        if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
                            el.addClass('sticky');
                            $('.dashboard .admin-page-content.sticky .vgt-responsive').height($(window).height() - 340);
                            $('#page-content-wrapper').addClass('sticky-footer');
                        }
                        else if (stickyTop12 > windowTop && el.is('.sticky')) {
                            el.removeClass('sticky');
                            $('.dashboard .admin-page-content .vgt-responsive').removeAttr('style');
                            $('#page-content-wrapper').removeClass('sticky-footer');
                        }
                    }
                });
            },500); */
        },
        methods: {
            getFormMasterData: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/form/master/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.notificationTypeArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            editSelected: function () {
                var selectedDataArr = [];
                var selectedFormEmailManager = this.$refs["listFormEmailManager"].selectedRows;
                for (var i = 0; i < selectedFormEmailManager.length; i++) {
                    selectedDataArr.push(this.$refs["listFormEmailManager"].selectedRows[i].id);
                }
                self.selectedFormEmailManagerDataArr = selectedDataArr;
                
                localStorage.setItem('changeSelectData', self.selectedFormEmailManagerDataArr);
                self.$router.push({name: "MultyAddUpdateFormEmailManager"});
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadFormEmailManager();
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadFormEmailManager();
            },
            addFormEmailManager: function() {
                self.$router.push("/form/email/manager/add");
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({ page: params.currentPage });
                self.loadFormEmailManager();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({ perPage: params.currentPerPage });
                    self.totalRecords = self.totalRecords;
                    self.loadFormEmailManager();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: "id";
                    field: "customer_name";
                    field: "notification_type";
                    field: "to_email";
                    field: "cc_email";
                    field: "updated_by";
                    field: "updated_at";
                }
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (
                    self.firstLoad == 1 ||
                    filters.id ||
                    filters.customer_name ||
                    filters.notification_type ||
                    filters.to_email ||
                    filters.cc_email ||
                    filters.updated_by ||
                    filters.updated_at
                ) {
                    self.loadFormEmailManager();
                }
            },
            selectionChanged() {
                self.selectedRows = self.$refs["listFormEmailManager"].selectedRows.length;
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    }
                });
                self.loadFormEmailManager();
            },
            deleteFormEmailManager: function(id) {
                let deleteArray = [];
                id = (id === null || typeof (id) === "undefined" || id == '' || id == 0) ? 0 : id;
                if(id != 0) {
                    deleteArray.push(id);
                } else {
                    var parRequestDeleteArr = [];
                    var selectedPARRequest = this.$refs["listFormEmailManager"].selectedRows;
                    for (var i = 0; i < selectedPARRequest.length; i++) {
                        parRequestDeleteArr.push(this.$refs["listFormEmailManager"].selectedRows[i].id);
                    }
                    deleteArray = parRequestDeleteArr;
                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to delete this Form Email Manager(s)!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: async () => {
                        try {
                            var config = {
                                headers: {Authorization:localStorage.getItem("access_token")},
                                data : {
                                    deleteArr: deleteArray,
                                }
                            };
                            HTTP.delete("/form/email/manager/delete", config)
                                .then(function (response) {
                                    if (response.data.code == '200') {
                                        self.loadFormEmailManager();
                                    }
                                })
                                .catch(function (error) {
                                    self.catchHandler(err, function () {});
                                });
                        } catch (error) {
                            Swal.showValidationMessage(`
                                Request failed: ${error}
                            `);
                        }
                        allowOutsideClick: () => !Swal.isLoading()
                    }
                })
            },
            loadCustNotificationModel: function() {
                jQuery.noConflict();
                self.getAllCustomer();
                $('#addCustNotificationModal').modal('show');
            },
            onChnageCustomer:function() {
                self.customerError = "";
            },
            changedValue: function (value) {
                /*console.log(value);*/
            },
            checkToEmailTag: function(obj) {
                self.toEmailError = "";
                self.isValidToEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidToEmailTag = false;
                    self.toEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            checkCCEmailTag: function(obj) {
                self.ccEmailError = "";
                self.isValidCCEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidCCEmailTag = false;
                    self.ccEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            getAllCustomer: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/customer/all/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.customerArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            checkForm: function() {
                var checked = true;
                self.customerError = '';
                self.notificationTypeError = '';
                self.toEmailError = "";
                self.ccEmailError = "";

                if (self.customerId == null || !self.customerId.value) {
                    self.customerError = "Select Customer";
                    checked = false;
                }

                console.log(self.notificationType);
                if (!self.notificationType || self.notificationType.length == 0) {
                    self.notificationTypeError = "Select Notification Type";
                    checked = false;
                }

                if (self.toEmailTagsArr.length == 0) {
                    self.isValidToEmailTag = false;
                    self.toEmailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            saveCutomerNotification: function() {
                if (self.isValidCCEmailTag && self.isValidToEmailTag && self.checkForm()) {
                    var notification_type_id = '';
                    if( self.notificationType && self.notificationType.length > 0 ) {
                        for (var i = 0; i < self.notificationType.length; i++) {
                            notification_type_id += (self.notificationType[i].value) + ',';
                        }
                        notification_type_id = notification_type_id.replace(/,\s*$/, "");
                    }

                    var toEmailData = "";
                    if(self.toEmailTagsArr && self.toEmailTagsArr.length > 0) {
                        for(var index = 0;index<self.toEmailTagsArr.length;index++) {
                            if(!toEmailData.includes(self.toEmailTagsArr[index].text)) {
                                toEmailData += (self.toEmailTagsArr[index].text) + ',';
                            }
                        }
                        toEmailData = toEmailData.replace(/,\s*$/, "");
                    }

                    var ccEmailData = "";
                    if(self.ccEmailTagsArr && self.ccEmailTagsArr.length > 0) {
                        for(var index = 0;index<self.ccEmailTagsArr.length;index++) {
                            if(!ccEmailData.includes(self.ccEmailTagsArr[index].text)) {
                                ccEmailData += (self.ccEmailTagsArr[index].text) + ',';
                            }
                        }
                        ccEmailData = ccEmailData.replace(/,\s*$/, "");
                    }

                    var config = {
                        headers: {Authorization:localStorage.getItem("access_token")},
                    };
                     
                    self.saveBtnName = 'Saving ...';
                    $('#saveBtn').prop("disabled", true);
                    $('#closeBtn').prop("disabled", true);
                    var fields = {
                        customer_id: self.customerId.value,
                        notification_type_list: notification_type_id,
                        to_email: toEmailData,
                        cc_email: ccEmailData,
                    };
                    self.showLoader();
                    HTTP.post('/multiple/form/email/manager/add/update', fields, config)
                        .then(response => {
                            self.hideLoader();
                            self.resetCustNotificationModel();
                            if(response.data.code == 200) {
                                self.loadFormEmailManager();
                                $('#addCustNotificationModal').modal('hide');
                                self.showSAlert(response.data.message, 'success', false);
                            } else {
                                self.showSAlert(response.data.message, 'error', false);
                            }
                        })
                        .catch(function (err) {
                            self.resetCustNotificationModel();
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
                }
            },
            resetCustNotificationModel : function() {
                self.customerId = "";
                self.notificationType = "";

                self.toEmail = "";
                self.toEmailTagsArr = [];
                self.isValidToEmailTag = true;

                self.ccEmail = "";
                self.ccEmailTagsArr = [];
                self.isValidCCEmailTag = true;

                self.saveBtnName = 'Save';
                $('#saveBtn').prop("disabled", false);
                $('#closeBtn').prop("disabled", false);
            },
            loadFormEmailManager: function() {
                self.storeFilters('formemailmanagerlist', self.serverParams, false);
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    tz: moment.tz.guess(),
                };
                HTTP.post("/form/email/manager/list", fields, config)
                    .then(function(response) {
                        if (response.data.code == "200") {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                        }
                        self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                    })
                    .catch(function(err) {
                        console.log('err', err)
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                //self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            }
        }
    };
    EventBus.$on("role", function(isLogin, roleId, roleName) {
        if (typeof self != "undefined") {
            self.roleId = roleId;
        }
    });
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            for (var i = 0; i < permissionArray.length; i++) {
                self.permissionsArray.push(permissionArray[i].name);
            }
        }
    });
</script>
<style>
.location-listing .admin-page-content.sticky{
    left: 330px;
    right: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/FormEmailManagerMaster/ListFormEmailManager.vue